module.exports = __webpack_public_path__ + "img/bg.afc94a39.jpg";